<template>
  <v-container fluid class="bg-white">
    <template v-if="!generalInfo.loading">
      <search-bar class="pb-0 pt-0" />
      <v-row no-gutters class="mt-4">
        <v-col cols="12" sm="6" md="3">
          <director-card
            :loading="generalInfo.loading"
            :user="activeUsername?.username"
            :chnl="user.VTWEG"
            :data="generalInfo.data"
            :error="generalInfo.errorMsg"
          />
        </v-col>

        <v-col cols="12" sm="6" md="9">
          <orders-table
            :user="activeUsername?.username"
            :chnl="user.VTWEG"
            class="pa-3"
          />
        </v-col>
      </v-row>
      <monthly-summary :chnl="user.VTWEG" class="ma-3" />

      <fill-rate
        :user-id="isRM ? activeUsername?.username : 0"
        :option="isRM ? 'GR' : 'D'"
        :chnl="user.VTWEG"
      />

      <backorders
        :user="activeUsername?.username"
        :chnl="user.VTWEG"
        class="ma-3"
      />

      <users-list
        :user="activeUsername?.username"
        :chnl="user.VTWEG"
        class="ma-3"
      />

      <month-end :user="activeUsername?.username" :chnl="user.VTWEG" />
    </template>
    <alert-prominent
      v-if="generalInfo.errorMsg"
      :message="generalInfo.errorMsg"
      class="ma-3"
    />

    <confidentiality-notice />
  </v-container>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import axios from '@/plugins/axios';
  import { MetaRoles, Roles } from '@/core/constants/roleConstants';
  import activeUsernameMixin from '@/mixins/activeUsernameMixin';
  import { getGeneralInfo } from '@/repositories/Daily';

  import ConfidentialityNotice from '@/components/ConfidentialityNotice.vue';
  import FillRate from '@/views/fill_rate/FillRate.vue';
  import AlertProminent from '@/components/AlertProminent.vue';

  import OrdersTable from '../components/OrdersTable.vue';
  import SearchBar from './components/SearchBar.vue';
  import MonthlySummary from '../components/MonthlySummary.vue';

  import Backorders from '../components/Backorders.vue';
  import UsersList from '../components/UsersList.vue';
  import MonthEnd from './includes/MonthEnd.vue';
  import DirectorCard from './includes/DirectorCard.vue';

  export default {
    name: 'DirectorHome',
    components: {
      SearchBar,
      ConfidentialityNotice,
      OrdersTable,
      MonthlySummary,
      FillRate,
      Backorders,
      UsersList,
      MonthEnd,
      AlertProminent,
      DirectorCard,
    },
    mixins: [activeUsernameMixin],
    data: () => ({
      generalInfo: {
        data: null,
        loading: false,
        errorMsg: null,
      },
    }),
    computed: {
      isRM() {
        return this.$route.meta.role === MetaRoles.RegionalManager;
      },
      ...mapGetters({
        user: 'auth/user',
      }),
    },
    created() {
      this.activeLoader();
      if (
        this.$hasAnyRole([
          Roles.DIRECTOR,
          Roles.REGIONAL_MANAGER,
          Roles.SUB_DIRECTOR,
          Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
          Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
        ])
      ) {
        this.fetchGeneralInfo();
      } else {
        this.getDefaultUserInfo();
      }
    },
    methods: {
      async getDefaultUserInfo() {
        try {
          this.activeLoader();
          this.generalInfo.loading = true;
          const response = await axios.post('/director-daily/general-info', {
            channel: this.user.VTWEG,
            isRM: false,
          });
          if (response && response.data) {
            // Handle the default user info as needed
            this.generalInfo.data = response.data;
            this.$setLocalStorageDirector(this.generalInfo.data.user.id);
          }
        } catch (error) {
          this.$toast.error('Error al consultar la información del usuario');
        } finally {
          this.generalInfo.loading = false;
          this.desactiveLoader();
        }
      },
      async fetchGeneralInfo() {
        try {
          this.generalInfo.loading = true;
          this.generalInfo.errorMsg = null;

          this.generalInfo.data = await getGeneralInfo(
            this.activeUsername?.username,
            this.user.VTWEG
          );
        } catch (error) {
          this.generalInfo.errorMsg =
            'Error al consultar información del director:';
        } finally {
          this.generalInfo.loading = false;
          this.desactiveLoader();
        }
      },
      ...mapActions({
        activeLoader: 'loader/activeLoader',
        desactiveLoader: 'loader/desactiveLoader',
      }),
    },
  };
</script>
